import { useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { FeedsState } from './Feeds.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface FeedsPropsTypes {
    eventId: EventId
}

export const Feeds = observer('Feeds', (propsIn: FeedsPropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const { sdkStaff } = useAppStateContext();
    const [timeEventSettingsState] = useState(() => new FeedsState(() => props.eventId, sdkStaff));

    const {
        isLoadingEventUpdate,
        feedSettingsUpdates, onChangeFeedSettingsUpdates,
        feedSettingsEachWay, onChangeFeedSettingsEachWay,
        feedSettingsPrices, onChangeFeedSettingsPrices,
        feedSettingsResults, onChangeFeedSettingsResults
    } = timeEventSettingsState;

    return (
        <section className={'event-details-box last' /*  disabled: !event.getIn([ 'feedData', 'feedId' ]) } */}>
            <h4>Feeds <span style={{ fontSize: '10px' }}>{isLoadingEventUpdate ? 'Making changes, wait...' : null}</span></h4>
            <div>
                <div className='row'>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={feedSettingsUpdates}
                                    onChange={onChangeFeedSettingsUpdates}
                                    disabled={feedSettingsUpdates === undefined}
                                />
                                <span>Feed updates</span>
                            </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={feedSettingsResults}
                                    onChange={onChangeFeedSettingsResults}
                                    disabled={feedSettingsResults === undefined}
                                />
                                <span>Feed results</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={feedSettingsEachWay}
                                    onChange={onChangeFeedSettingsEachWay}
                                    disabled={feedSettingsEachWay === undefined}
                                />
                                <span>Each Way</span>
                            </label>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className={'element checkbox'}>
                            <label>
                                <input
                                    type='checkbox'
                                    checked={feedSettingsPrices}
                                    onChange={onChangeFeedSettingsPrices}
                                    disabled={feedSettingsPrices === undefined}
                                />
                                <span>Feed prices</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});
